import { render, staticRenderFns } from "./CategorySummaryTable.vue?vue&type=template&id=170b7c64&scoped=true&"
import script from "./CategorySummaryTable.vue?vue&type=script&lang=js&"
export * from "./CategorySummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./CategorySummaryTable.vue?vue&type=style&index=0&id=170b7c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b7c64",
  null
  
)

export default component.exports